<!-- Answers: completed previous month vs month before vs same month last year (full months only). -->
<template>
    <dashboard-panel title="Previous month comparisons" :subtitle="subtitle">
        <dashboard-bar-chart-host
            wrap-class="compact"
            :labels="labels"
            :datasets="datasets"
            :extra-options="chartOptions"
        />
    </dashboard-panel>
</template>

<script setup>
import { computed } from "vue";
import DashboardBarChartHost from "./DashboardBarChartHost.vue";
import DashboardPanel from "./DashboardPanel.vue";

const props = defineProps({
    labels: { type: Array, default: () => [] },
    datasets: { type: Array, default: () => [] },
});

// Subtitle from labels + first dataset so totals always match the chart.
const subtitle = computed(() => {
    const values = props.datasets?.[0]?.data || [];
    if (!props.labels?.length) {
        return "";
    }
    return props.labels
        .map((label, index) => `${label}: ${Number(values[index]) || 0}`)
        .join(" · ");
});

const chartOptions = { plugins: { legend: { display: false } } };
</script>
